<template>
  <div class="product-dropdown-menu">
    <div class="row">
      <product-section
        :is-section-hidden="isSectionHidden"
        @toggleSection="toggleSection"
      />

      <popular-tags-section
        :is-section-hidden="isSectionHidden"
        @toggleSection="toggleSection"
      />

      <filter-section
        :is-section-hidden="isSectionHidden"
        @change="getCheckboxValue"
        @inventoryCriteriaDropdownChange="onInventoryCriteriaDropdownChangeOnProductFilterTab"
        @inventoryCriteriaInputTyped="onInventoryCriteriaInputTypedOnProductFilterTab"
        @onApplyClicked="onApplyClicked"
        @toggleSection="toggleSection"
      />
    </div>
  </div>
</template>

<script>

import FilterSection from '~/components/common/TopMenu/ProductDropdownMenu/FilterSection'
import PopularTagsSection from '~/components/common/PopularTagsSection'
import ApplyButton from '~/components/common/TopMenu/ApplyButton'
import ProductSection from '~/components/common/TopMenu/ProductDropdownMenu/ProductSection'
import { EventBus } from '~/helpers/miscs'
import { mapGetters, mapActions } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'ProductDropdownMenu',
  components: { ProductSection, ApplyButton, PopularTagsSection, FilterSection },
  data () {
    return {
      selectedCheckBox: {},
      currentPage: 1,
      availabilityInventoryCriteriaDropdownData: '',
      availabilityInventoryCriteriaInputData: '',
      isSectionHidden: true // Initially hide the section
    }
  },
  computed: {
    ...mapGetters({
      productFilterTabs: 'menus/productFilterTabs',
      buildFilterData: 'menus/buildFilterData',
      buildPFTabData: 'menus/buildFilterData'
    }),
    buildProductFilterTabData () {
      if (!!this.availabilityInventoryCriteriaDropdownData && !!this.availabilityInventoryCriteriaInputData) {
        return {
          ...this.buildPFTabData,
          availability_inventory_criteria: `${this.availabilityInventoryCriteriaDropdownData},${this.availabilityInventoryCriteriaInputData}`
        }
      }

      return this.buildPFTabData
    }
  },
  methods: {
    ...mapActions({
      setSelectedCheckBox: 'menus/setSelectedCheckBox',
      fetchCatalogProducts: 'catalog_products/fetchCatalogProducts',
      setExpandSideFilter: 'menus/setExpandSideFilter',
      fetchProductFilterTabMenu: 'menus/fetchProductFilterTabMenu',
      clearFilter: 'catalog_products/clearFilter',
      setSelectedSearchFilterCheckBox: 'menus/setSelectedSearchFilterCheckBox'
    }),
    toggleSection () {
      this.isSectionHidden = !this.isSectionHidden
    },
    getCheckboxValue (value) {
      this.selectedCheckBox = value
    },
    onChangeOnProductFilterTab () {
      this.reloadProductsData()
    },
    onInventoryCriteriaDropdownChangeOnProductFilterTab (e) {
      if (e === 'set') {
        this.availabilityInventoryCriteriaDropdownData = null
        return
      }

      if (e === 'clear') {
        this.availabilityInventoryCriteriaDropdownData = null
        this.availabilityInventoryCriteriaInputData = null

        this.onChangeOnProductFilterTab()
        return
      }

      this.availabilityInventoryCriteriaDropdownData = e
      if (this.availabilityInventoryCriteriaInputData) {
        this.onChangeOnProductFilterTab()
      }
    },
    onInventoryCriteriaInputTypedOnProductFilterTab: debounce(function (e) {
      // console.log(e)
      this.availabilityInventoryCriteriaInputData = Number(e)
      if (this.availabilityInventoryCriteriaDropdownData) {
        this.onChangeOnProductFilterTab()
      }
    }, 500),

    async reloadProductsData () {
      await this.fetchCatalogProducts({ urlEndpoint: `/api/product?page=${this.currentPage}&${new URLSearchParams(this.buildProductFilterTabData).toString()}` })
    },

    async onApplyClicked () {
      const isProductsRoute = this.$route.name === 'products'

      // Emit event to close popper regardless of route
      EventBus.$emit('close-product-popper')
      if (!isProductsRoute) {
        this.$router.push({ name: 'products' })
        const tabs = ['brand', 'sub_brand', 'department', 'category'].filter(tab => this.buildFilterData[tab])
        if (tabs.length > 0) {
          this.reloadProductsData()
          this.setSelectedSearchFilterCheckBox({ payload: this.buildFilterData, filterName: { tab: tabs } })
          this.setExpandSideFilter({ payload: { tab: tabs } })
        }
      } else {
        const tabs = ['brand', 'sub_brand', 'department', 'category'].filter(tab => this.buildFilterData[tab])
        if (tabs.length > 0) {
          this.reloadProductsData()
          this.setExpandSideFilter({ payload: { tab: tabs } })
        }
      }
    }
  }
}
</script>
<style scoped>
.product-dropdown-menu {
  height: 100%;
  .row {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 685px;
  }
}
@media (max-height: 800px) {
  .product-dropdown-menu {
    .row {
      height: calc(100vh - 200px);
  }
}
}
</style>
